import { module as m } from 'modujs';
import axios from 'axios';
import Qs from 'qs';
import gsap from "gsap";

export default class extends m {
    constructor (m) {
        super(m);

        // VAR
        this.isFiltering = false;
        this.isProcessing = false;
        this.isFirstLoad = true;
        this.showLoadMoreButton = true;
        this.offset = 0;
        this.filter = "";
        this.postType = this.getData('type');
        this.currentCategoryElement = null;

        this._onClickDocument = this._onClickDocument.bind(this);

        if (this.getData('showfilters') !== 'false') {
            // FUNC
            this._loadNews = this._loadNews.bind(this);
    
            // EVENTS
            this.events = {
                click : {
                    filters: '_toggleFilters',
                    category: '_filterNews',
                    button: '_loadMore'
                }
            }
        }
    }

    init () {
        this.offset = this.$('container')[0].querySelectorAll('.news-item').length;
        if(this.offset === 10)
            gsap.set(this.$('button')[0], {
                autoAlpha: 1,
            });
    }

    _toggleFilters (e) {
        const filters = this.$('filters')[0];
        if (filters.classList.contains('-opened')) {
            this._hideFilters();
        } else {
            this._showFilters();
        }
    }

    _showFilters () {
        this.$('filters')[0].classList.add('-opened');
        document.addEventListener('click', this._onClickDocument);
    }

    _hideFilters () {
        this.$('filters')[0].classList.remove('-opened');
        document.removeEventListener('click', this._onClickDocument);
    }

    _onClickDocument (e) {
        if (e.target.closest('.news-filters') == null) {
            this._hideFilters();
        }
    }

    _filterNews (e) {
        const target = e.currentTarget;
        const category = target.closest('li').dataset.category;

        this._hideFilters();

        this.$('filters')[0].querySelector('.current .category').innerHTML = e.target.textContent;

        this.filter = category;
        this.isFiltering = true;
        this.offset = 0;
        this._loadNews();
    }

    /**
     * Update current category
     * @private
     */
    _updateCurrentCategory() {
        this.$('category').forEach(category => {
            if (category.dataset.category == this.filter) {
                category.classList.add('-active');
            } else {
                category.classList.remove('-active');
            }
        });
    }

    /**
     * Load more
     * @private
     */
    _loadMore() {
        this._loadNews();
    }

    /**
     * Load news
     * @private
     */
    _loadNews() {
        if(!this.isProcessing) {
            this.isProcessing  = true;

            this._updateCurrentCategory()

            const _tl = gsap.timeline({
                onComplete: () => {
                    if(this.isFiltering)
                        this.$('container')[0].innerHTML = "";

                    this._processLoading();
                }
            });
            if(this.isFiltering) {
                _tl.to(this.$('wrapper')[0], {
                    duration: 0.6,
                    autoAlpha: 0,
                    height: 0,
                    ease: 'power4.out'
                });
            }
            _tl.to(this.$('button')[0], {
                duration: 0.6,
                autoAlpha: 0,
                ease: 'power4.out'
            }, 0);
            _tl.to(this.$('loader')[0], {
                duration: 0.6,
                autoAlpha: 1,
                ease: 'power4.out'
            }, 0);
        }
    }

    _processLoading() {

        let ajaxData = {
            action: 'ajax_function_manager',
            fn: 'getNews',
            filter: this.filter,
            offset: this.offset,
            type: this.postType,
            lang: CURRENT_LANG.code
        };

        axios({
            method:'get',
            url: AJAX_URL + '?' + Qs.stringify( ajaxData ),
            responseType: 'json'
        })
            .then((response) => {
                const htmlString = response.data.template;

                this.$('container')[0].innerHTML += htmlString;
                
                this.offset = this.$('container')[0].querySelectorAll('.news-item').length;
                this.showLoadMoreButton = response.data.found_posts >= 10;
                console.log(response.data.found_posts);
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(() => {
                const _tl = gsap.timeline({
                    onComplete: () => {
                        this.call('update', {}, 'Load');
                        this.$('wrapper')[0].style.height = "auto";
                        this.isProcessing = false;
                        this.isFirstLoad = false;
                        this.isFiltering = false;
                    }
                });
                _tl.to(this.$('loader')[0], {
                    duration: 0.6,
                    autoAlpha: 0,
                    ease: 'power4.out'
                });
                if(this.showLoadMoreButton) {
                    _tl.to(this.$('button')[0], {
                        duration: 0.6,
                        autoAlpha: 1,
                        ease: 'power4.out'
                    }, 0);
                }
                _tl.to(this.$('wrapper')[0], {
                    duration: 1,
                    autoAlpha: 1,
                    height: this.$('container')[0].clientHeight,
                    ease: 'power4.inOut',
                    onComplete: () => {
                        this.$('container')[0].style.height = 'auto';
                    }
                }, 0.3);
            });
    }
}